"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const react_redux_1 = require("react-redux");
const yup = __importStar(require("yup"));
const uuid_1 = require("uuid");
const selectors_1 = require("@/store/ducks/users/selectors");
const evaluators_1 = require("@/store/ducks/evaluators");
const index_view_1 = __importDefault(require("./index.view"));
const updateEvaluatorsInSystemsUseCase_1 = __importDefault(require("@/useCases/evaluators/updateEvaluatorsInSystemsUseCase"));
const listEvaluatorsInSystem_1 = __importDefault(require("@/useCases/evaluators/listEvaluatorsInSystem"));
function EvaluatorGroupTable({ group }) {
    const users = (0, react_redux_1.useSelector)(selectors_1.usersSelector);
    const dispatch = (0, react_redux_1.useDispatch)();
    const usersOptions = react_1.default.useMemo(() => {
        return users.map((user) => {
            return {
                ...user,
                operation: null,
            };
        });
    }, [users]);
    const initialValues = react_1.default.useMemo(() => {
        return {
            evaluatorsGroup: group?.evaluators,
        };
    }, [group.evaluators]);
    yup.addMethod(yup.array, "uniqueArray", function (mapper = (component) => component, message = "") {
        return this.test("uniqueArray", message, function (list) {
            const uniqueValues = new Set(list?.map(mapper));
            const duplicateItensPositions = [];
            const duplicateIds = list
                ?.map((item) => item?.id)
                .filter((item, index, ids) => ids.indexOf(item) !== index);
            list?.forEach((component) => {
                if (duplicateIds?.includes(component?.id)) {
                    duplicateItensPositions.push(list.indexOf(component));
                }
            });
            const duplicateComponentsErrors = list
                ?.filter((component) => {
                if (component?.id && duplicateIds?.includes(component?.id)) {
                    return component;
                }
            })
                .reduce((acc, curr) => {
                const duplicateComponentIndex = list.indexOf(curr);
                acc = {
                    ...acc,
                    [`${[duplicateComponentIndex]}`]: {
                        username: "Duplicate Value",
                    },
                };
                return acc;
            }, {});
            if (uniqueValues?.size !== list?.length) {
                throw this.createError({
                    path: `${this.path}`,
                    message: duplicateComponentsErrors || "Duplicate Value",
                });
            }
            return true;
        });
    });
    const validatorSchema = yup.object().shape({
        evaluatorsGroup: yup
            .array()
            .of(yup.object().shape({
            id: yup.string(),
            username: yup.string().required("Required"),
            operation: yup.string().nullable(),
        }))
            .uniqueArray((value) => {
            return value?.id;
        }, "Error"),
    });
    const onOpenRemoveEvaluatorModal = (evaluatorToBeDeleted) => {
        dispatch((0, evaluators_1.openDeleteEvaluatorModal)({
            evaluatorToBeDeleted,
            systemOfEvaluatorToBeDeleted: {
                id: group.id,
                name: group.name,
            },
        }));
    };
    const onSubmit = async (values) => {
        const evaluatorsInSystem = await (0, listEvaluatorsInSystem_1.default)(group.id);
        const usersToBeAdded = values.evaluatorsGroup.filter((value) => {
            return (value.operation === "add" &&
                evaluatorsInSystem.findIndex((user) => user.id === value.id) === -1);
        });
        usersToBeAdded.map(async (user) => {
            return await (0, updateEvaluatorsInSystemsUseCase_1.default)(user.id, [group.id], user.operation)(dispatch);
        });
    };
    return (react_1.default.createElement(formik_1.Formik, { validationSchema: validatorSchema, onSubmit: onSubmit, initialValues: initialValues, validateOnChange: true, enableReinitialize: false, validateOnBlur: true }, (props) => {
        return (react_1.default.createElement(index_view_1.default, { users: usersOptions, key: (0, uuid_1.v4)(), isLoading: group.isLoading, evaluatorGroupName: group.name, rows: props.values, onDelete: onOpenRemoveEvaluatorModal }));
    }));
}
exports.default = EvaluatorGroupTable;
